/**
 * Built-in 3D text font (R2). Stroke-based vector glyphs on a 6x8 unit
 * em grid (origin at the baseline left). Each glyph is a list of polylines;
 * TextObject extrudes every polyline into a quad strip to build a real
 * vector-surface solid. No external font file — offline-safe (§7).
 */

export type Stroke = [number, number][];

export const GLYPH_EM_WIDTH = 5.0;
export const GLYPH_EM_HEIGHT = 8.0;
export const GLYPH_ADVANCE = 6.0;

export const GLYPHS: Record<string, Stroke[]> = {
    ' ': [],
    '!': [[[3, 2], [3, 8]]],
    '.': [[[3, 2], [3, 1.6]]],
    ',': [[[3, 2], [2, 0.5]]],
    '-': [[[1.5, 4], [4.5, 4]]],
    '+': [[[3, 2.5], [3, 5.5]], [[1.5, 4], [4.5, 4]]],
    '=': [[[1.5, 4.6], [4.5, 4.6]], [[1.5, 3.4], [4.5, 3.4]]],
    ':': [[[3, 2], [3, 1.6]], [[3, 5], [3, 4.6]]],
    '/': [[[1, 0], [5, 8]]],
    '\\': [[[1, 8], [5, 0]]],
    '(': [[[4, 7.5], [2.2, 4], [4, 0.5]]],
    ')': [[[2, 7.5], [3.8, 4], [2, 0.5]]],
    '#': [[[2, 0], [2.8, 8]], [[4, 0], [4.8, 8]], [[1, 2.5], [5.6, 2.5]], [[1, 5.5], [5.6, 5.5]]],
    '0': [[[1, 0], [5, 0], [5, 8], [1, 8], [1, 0]], [[1, 8], [5, 0]]],
    '1': [[[1.8, 6.5], [3.2, 8]], [[3.2, 8], [3.2, 0]], [[1.8, 0], [4.6, 0]]],
    '2': [[[1, 6.5], [2.5, 8], [4, 6.5], [5, 0]], [[1.2, 0], [5, 0]]],
    '3': [[[1, 7], [3, 8], [4.5, 6.5], [3.5, 4.5], [5, 3], [3, 0.5], [1, 1.5]]],
    '4': [[[4.5, 0], [4.5, 8], [1, 3], [5.5, 3]]],
    '5': [[[4.5, 8], [1.5, 8], [1.2, 4.5], [4, 5], [5, 3], [3.5, 0], [1, 0.5]]],
    '6': [[[4.5, 8], [2, 5], [1, 2.5], [2.5, 0.5], [4.5, 2], [4.5, 4.5], [1.5, 4.5]]],
    '7': [[[1, 8], [5, 8], [2.8, 0]]],
    '8': [[[3, 4.5], [1.2, 6.2], [3, 8], [4.8, 6.2], [3, 4.5], [1.2, 2.8], [3, 0.5], [4.8, 2.8], [3, 4.5]]],
    '9': [[[1.5, 0], [4, 3], [5, 5.5], [3.5, 7.5], [1.5, 6], [1.5, 3.5], [4.5, 3.5]]],
    A: [[[1, 0], [3, 8], [5, 0]], [[1.8, 3.5], [4.2, 3.5]]],
    B: [[[1, 0], [1, 8], [3.5, 8], [4.8, 6.8], [3.5, 4.2], [1, 4.2]], [[3.5, 4.2], [5, 2.8], [3.5, 0], [1, 0]]],
    C: [[[4.8, 7], [3, 8], [1.2, 6.5], [1.2, 1.5], [3, 0], [4.8, 1]]],
    D: [[[1, 0], [1, 8], [3, 8], [5, 6], [5, 2], [3, 0], [1, 0]]],
    E: [[[5, 8], [1, 8], [1, 0], [5, 0]], [[1, 4], [4.2, 4]]],
    F: [[[5, 8], [1, 8], [1, 0]], [[1, 4], [4.2, 4]]],
    G: [[[4.8, 7], [3, 8], [1.2, 6.5], [1.2, 1.5], [3, 0], [4.8, 1.5], [4.8, 4], [3.4, 4]]],
    H: [[[1, 8], [1, 0]], [[5, 8], [5, 0]], [[1, 4], [5, 4]]],
    I: [[[1.8, 8], [4.2, 8]], [[3, 8], [3, 0]], [[1.8, 0], [4.2, 0]]],
    J: [[[4.8, 8], [4.8, 1.5], [3, 0], [1.5, 1]]],
    K: [[[1, 8], [1, 0]], [[5, 8], [1, 4], [5, 0]]],
    L: [[[1, 8], [1, 0], [5, 0]]],
    M: [[[1, 0], [1, 8], [3, 3.5], [5, 8], [5, 0]]],
    N: [[[1, 0], [1, 8], [5, 0], [5, 8]]],
    O: [[[1, 0], [5, 0], [5, 8], [1, 8], [1, 0]]],
    P: [[[1, 0], [1, 8], [3.5, 8], [5, 6.5], [3.5, 4.5], [1, 4.5]]],
    Q: [[[1, 0], [5, 0], [5, 8], [1, 8], [1, 0]], [[3.5, 4.5], [5.5, 0]]],
    R: [[[1, 0], [1, 8], [3.5, 8], [5, 6.5], [3.5, 4.5], [1, 4.5]], [[3.2, 4.5], [5, 0]]],
    S: [[[5, 7.5], [3, 8], [1.2, 6.8], [1.2, 5], [3.5, 4.4], [4.8, 3.2], [4.8, 1.2], [3, 0], [1, 0.8]]],
    T: [[[1, 8], [5, 8]], [[3, 8], [3, 0]]],
    U: [[[1, 8], [1, 1.5], [3, 0], [5, 1.5], [5, 8]]],
    V: [[[1, 8], [3, 0], [5, 8]]],
    W: [[[1, 8], [2.2, 0], [3, 5], [3.8, 0], [5, 8]]],
    X: [[[1, 8], [5, 0]], [[1, 0], [5, 8]]],
    Y: [[[1, 8], [3, 4], [5, 8]], [[3, 4], [3, 0]]],
    Z: [[[1, 8], [5, 8], [1, 0], [5, 0]]],
};

/** Total advance width of a string at em height 1. */
export function measureText(text: string): number {
    return text.length > 0 ? text.length * GLYPH_ADVANCE / GLYPH_EM_HEIGHT : 0;
}

/**
 * Extrude a string's strokes into a solid triangle mesh: every stroke
 * becomes a thin ribbon of width `stroke`, front and back caps closed by
 * a Z-depth box. Returns world-fit vertices scaled to `height`.
 */
export function strokeTextToMesh(
    text: string,
    height: number,
    depth: number,
    strokeRatio = 0.12
): { vertices: number[][]; indices: number[][] } {
    const s = height / GLYPH_EM_HEIGHT;
    const stroke = height * strokeRatio;
    const vertices: number[][] = [];
    const indices: number[][] = [];
    const half = depth / 2;
    const emitQuad = (a: [number, number, number], b: [number, number, number], ang: number) => {
        // segment quad: extruded box along the stroke direction
        const nx = -Math.sin(ang) * stroke / 2, ny = Math.cos(ang) * stroke / 2;
        const base = vertices.length;
        const corners: [number, number][] = [
            [a[0] + nx, a[1] + ny], [a[0] - nx, a[1] - ny],
            [b[0] - nx, b[1] - ny], [b[0] + nx, b[1] + ny],
        ];
        corners.forEach(([x, y]) => { vertices.push([x, y, half]); vertices.push([x, y, -half]); });
        const v = (i: number, zSide: number) => base + i * 2 + zSide;
        // sides (2 quads per corner pair)
        for (let i = 0; i < 4; i++) {
            const j = (i + 1) % 4;
            indices.push([v(i, 0), v(j, 0), v(j, 1)], [v(i, 0), v(j, 1), v(i, 1)]);
        }
    };
    let x = 0;
    for (const ch of text.toUpperCase()) {
        const strokes = GLYPHS[ch] ?? GLYPHS['?'] ?? [];
        for (const strokePts of strokes) {
            let prev: [number, number] | null = null;
            for (const p of strokePts) {
                const q: [number, number] = [(x + p[0]) * s, p[1] * s];
                if (prev) {
                    const ang = Math.atan2(q[1] - prev[1], q[0] - prev[0]);
                    emitQuad([prev[0], prev[1], 0], [q[0], q[1], 0], ang);
                }
                prev = q;
            }
            if (strokePts.length === 1) {
                // dot: small box
                const p = strokePts[0];
                const q: [number, number] = [(x + p[0]) * s, p[1] * s];
                emitQuad([q[0] - stroke, q[1], 0], [q[0] + stroke, q[1], 0], 0);
            }
        }
        x += GLYPH_ADVANCE;
    }
    return { vertices, indices };
}
